import { render, staticRenderFns } from "./CoordinateDialog.vue?vue&type=template&id=41bcbb1a&scoped=true"
import script from "./CoordinateDialog.vue?vue&type=script&lang=js"
export * from "./CoordinateDialog.vue?vue&type=script&lang=js"
import style0 from "./CoordinateDialog.vue?vue&type=style&index=0&id=41bcbb1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bcbb1a",
  null
  
)

export default component.exports